import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DialogComponent } from '../../shared/component/dynamic-form/dialog-box/dialog-component';
import { PasswordRecoveryService } from './services/password-recovery.service';

@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss'],
  standalone: false,
})
export class PasswordRecoveryComponent {
  resetEnabled = false;
  userForm = new FormGroup({
    user: new FormControl('', Validators.required),
  });

  constructor(
    private passRecoveryService: PasswordRecoveryService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
  ) {}

  get user(): AbstractControl | null {
    return this.userForm.get('user');
  }

  enableReset(): boolean {
    return this.user?.valid;
  }

  resetPassword(): void {
    if (this.user?.valid) {
      const userValue = this.user.value;
      if (userValue) {
        this.passRecoveryService.recoverPassword(userValue).subscribe({
          // Pass the value of the FormControl
          next: () => {
            // Use the expected success message used in specs
            this.snackBar.open('Password reset successful', 'Close', {
              duration: 3000,
            });

            this.router.navigate(['/']);
          },
          error: () => {
            this.dialog.open(DialogComponent, {
              data: {
                message: 'Error resetting password',
              },
            });
          },
        });
      }
    }
  }
}
